/* first of all: the pop guard's listener must be on window before the router adds its own (utils/popguard.js) */
import '@/utils/popguard.js';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import 'virtual:uno.css';
/* THE BASE — every page of the old site loaded tokens.css first and nothing else was allowed to declare a
   colour, a curve or a radius that belongs there. It is the design's ground, carried over unchanged; the
   page-level stylesheets are imported by the views that need them, in the order their own <head> had. */
import '@/assets/styles/design/tokens.css';
import '@/assets/styles/index.css';
import App from '@/App.vue';
import router from '@/router';

/* html.kbd — the listener is moving by KEYBOARD (Tab); the pointer clears it again. It was deck.js's, and it is
   site-wide chrome: only under it does `:focus-visible` draw its white ring (listen.css), and only under it does
   the nav's avatar appear at all — the card's keyboard anchor, since Miya herself is a picture and cannot take
   focus. Without it Chrome lights :focus-visible after ANY key, so a mouse-clicked button flashed white on Esc,
   Space or an arrow. */
addEventListener(
  'keydown',
  (e) => {
    if (e.key === 'Tab') document.documentElement.classList.add('kbd');
  },
  true
);
addEventListener('pointerdown', () => document.documentElement.classList.remove('kbd'), true);

createApp(App).use(createPinia()).use(router).mount('#app');
